import { PersonalDataScreen } from '../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <PersonalDataScreen />;
}
